/**
 * These types were last sync'ed from artist portal interface
 * on Dec 12, 2023.
 */
import { TypeOfService } from "../api/communication";
import { Timestamp } from "../compat";
import { SecurePayload } from "../crypto";
import { SetSource } from "../source";

export interface LeadSource<T = Timestamp> {
  createdAt: T;
  source: SetSource;
  sourceId: string;
  meta?: { [key: string]: unknown };
}
export enum Gender {
  male = "Male",
  female = "Female",
  nonbinary = "Non-binary",
  notsay = "Prefer not to say",
}

export interface FanNonPrivateData<T = Timestamp> {
  name: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  location?: string;
  geo?: string;
  age?: number;
  gender?: keyof typeof Gender;
  lat?: number;
  lng?: number;
  createdAt: T;
  updatedAt: T;
  deletedAt?: T;
  consent?: boolean;
  smsOptIn?: boolean;
  sources: LeadSource[];
  optin?: Record<string, boolean>;

  // NEW
  phoneType?: TypeOfService;
}

export interface FanPrivateData {
  firstName?: string;
  lastName?: string;
  email: string;
  phone?: string;
  rawPhone?: string;
}

export type Fan<T = Timestamp> = FanNonPrivateData<T> & FanPrivateData;

/**
 * @path {/artist_groups/<artistId>/fans/<fanId>}
 */
export interface FanSecure<U = unknown> extends FanNonPrivateData {
  secure: SecurePayload<FanPrivateData, U>;
}

/**
 * Returns a reduced name: first name plus the first letter of the last name (if present).
 * Example: ("john", "doe") => "John D"
 */
export function getReducedName(firstName: string, lastName: string): string {
  const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
  const trimmedFirst = (firstName || "").trim();
  const trimmedLast = (lastName || "").trim();

  if (!trimmedFirst && !trimmedLast) {
    return "";
  }

  if (!trimmedLast) {
    return capitalize(trimmedFirst);
  }

  return `${capitalize(trimmedFirst)} ${trimmedLast.charAt(0).toUpperCase()}`;
}
